import { useState, useCallback, useEffect } from 'react';
import driverServices from 'services/driver.services';

export default function useGetDriverInstantPayoutType() {
  const [loading, setLoading] = useState(false);
  const [listDriverInstantPayoutTypes, setListDriverInstantPayoutTypes] = useState([]);

  const getDriverInstantPayoutTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await driverServices.listDriverInstantPayoutType();
      setListDriverInstantPayoutTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getDriverInstantPayoutTypes();
  }, []);

  return {
    loading,
    listDriverInstantPayoutTypes,
    getDriverInstantPayoutTypes
  };
}
